module.exports = __webpack_public_path__ + "static/media/wayfayer-big.07fdd49c.png";